// extracted by mini-css-extract-plugin
module.exports = {"background":"bj_fg","values":"bj_fq"};